<template>
  <div class="ControlLibrary"  >

    <model-close @close="$modal.hide('controlLibraryRightModel')"></model-close>
    <h5>控件设置</h5>
    <p class="des" >设置后新发起的合同有效</p>

    <div class="ControlLibraryList modal-box" >
      <div class="ControlLibraryList-ModalBox" style="margin-right: 25px">
        <!--        控件内容开始-->
        <ControlLibraryInput
          name="*控件名称"
          placeholder="请输入控件名称"
          field="name"
          :value="itemData.name"
          @update="update"
        ></ControlLibraryInput>

        <ControlLibrarySelect
          v-if=" !in_array(itemData.control_library_id,[13,14,15,16,17,18,19])"
          name="*是否必填"
          field="is_require"
          :value="itemData.is_require"
          :option-data="[  { name : '选填', value : -1 }, { name : '必填', value : 1 } ]"
          @update="update"
        ></ControlLibrarySelect>

        <ControlLibrarySelect
          v-if=" !in_array(itemData.control_library_id,[14,16,17,18,19])"
          :name="getFillName()"
          field="sign_id"
          :value="itemData.sign_id"
          :option-default=" {name : '不设置' , value : -1 }"
          :option-data="getSignList()"
          @update="update"
        ></ControlLibrarySelect>

        <ControlLibrarySelect
          v-if="in_array(itemData.control_library_id,[17,18,19])"
          name="*数据来源"
          field="auto_sign_filler"
          :value="itemData.auto_sign_filler"
          :option="getSignListName()"
          @update="update"
        ></ControlLibrarySelect>

        <div class="xian"></div>

        <ControlLibrarySelect
          v-if="itemData.display_date===1"
          name="时间格式"
          field="date"
          :value="itemData.date"
          :option="[ 'YYYY/MM/DD', 'YYYY-MM-DD', 'YYYY年MM月DD日']"
          @update="update"
        ></ControlLibrarySelect>

        <ControlLibrarySelect
          v-if="itemData.display_number===1"
          name="数字格式"
          field="font_number"
          :value="itemData.font_number"
          :option-data="[  { name : '默认', value : -1 }]"
          @update="update"
        ></ControlLibrarySelect>

        <ControlLibrarySelect
          v-if="itemData.display_money===1"
          name="金额格式"
          field="font_money"
          :value="itemData.font_money"
          :option-data="[  { name : '默认', value : -1 }]"
          @update="update"
        ></ControlLibrarySelect>


        <!--        合同编号-->
        <ControlLibraryInput
          v-if="itemData.display_doc_number===1"
          name="合同编号-前缀"
          placeholder="合同编号前缀:如2020, 可为空"
          field="doc_number_prefix"
          :value="itemData.doc_number_prefix"
          @update="update"
        ></ControlLibraryInput>

        <ControlLibrarySelect
          v-if="itemData.display_doc_number===1"
          name="合同编号-自增长度"
          field="doc_number_length"
          :value="itemData.doc_number_length"
          :option="doc_number_length_list"
          @update="update"
        ></ControlLibrarySelect>


        <ControlLibraryInput
          v-if="itemData.display_doc_number===1"
          name="合同编号-后缀"
          placeholder="合同编号后缀, 可为空"
          field="doc_number_suffix"
          :value="itemData.doc_number_suffix"
          @update="update"
        ></ControlLibraryInput>


        <ControlLibrarySelect
          v-if="itemData.display_font===1"
          name="字体"
          field="font_type"
          :value="itemData.font_type"
          :option-default="{name : '默认' , value : -1 }"
          :option="font"
          @update="update"
        ></ControlLibrarySelect>

        <ControlLibrarySelect
          v-if="itemData.display_font===1"
          name="字体大小"
          field="font_size"
          :value="itemData.font_size"
          :option-default="{name : '默认' , value : -1 }"
          :option="fontSize"
          @update="update"
        ></ControlLibrarySelect>

        <control-library-color
          v-if="itemData.display_color===1"
          name="文字颜色"
          field="color"
          :value="itemData.color"
          @update="update"
        ></control-library-color>

        <control-library-color
          v-if="itemData.display_background_color===1"
          name="背景颜色"
          field="background_color"
          :value="itemData.background_color"
          @update="update"
        ></control-library-color>

        <ControlLibrarySelect
          v-if="itemData.display_font_align===1"
          name="对齐方式"
          field="font_align"
          :value="itemData.font_align"
          :option-data="align"
          @update="update"
        ></ControlLibrarySelect>

        <ControlLibrarySelect
          v-if="itemData.display_font_underline===1"
          name="是否显示下划线"
          field="font_underline"
          :value="itemData.font_underline"
          :option-data="[  { name : '默认不显示', value : -1 },{ name : '显示', value : 1 }]"
          @update="update"
        ></ControlLibrarySelect>

        <ControlLibrarySelect
          v-if="itemData.display_select_seal===1"
          name="*印章类型"
          field="display_select_seal_value"
          :value="itemData.display_select_seal_value"
          :option-default="{name : '不设置' , value : -1 }"
          :option-data="seal_type"
          @update="update"
        ></ControlLibrarySelect>
        <!--        控件内容结束-->

      </div>

    </div>
  </div>
</template>

<script>

import ControlLibrarySelect from "./field/ControlLibrarySelect";
import ControlLibraryInput from "./field/ControlLibraryInput";
import ControlLibraryColor from "./field/ControlLibraryColor";
import ModelClose from "@/components/modal/modelClose";
import modal from "@/components/modal/modal";

export default {
  components: {
    ModelClose,
    ControlLibraryColor,
    ControlLibraryInput,
    ControlLibrarySelect
  },
  computed : {


    /**
     * 获取印章
     */
    getDefaultSeal() {

      let defaultContent = ""
      this.seal_type.forEach((item,index)=>{

        if (item.value=== this.itemData.display_select_seal_value)
          defaultContent = item

      });

      return defaultContent;
      //{name : '个人手写签名' , value :  'handwritten' }

    },

    getDefaultSignUser() {

      let defaultContent = ""

      this.tplContent.sign.forEach((item,index)=>{


        if (item.sign_role=== this.itemData.filler)
          defaultContent = {
            name : item.sign_role,
            value : item.sign_id
          }

      });


      return defaultContent ? defaultContent : {name : '不设置' , value : -1 };

    }
  },
  data() {
    return {
      colorSelect: "",
      modelBoxHeight : 600,
      backgroundColorSelect: "",
      fontSize: [],
      fontInterval: [],
      doc_number_length_list: [],
      font : [],
      align : [],
      seal_type : [],
      sign_list : []
    }
  },
  created() {
    this.getOption()
    setTimeout(()=>{
      modal.handle()
    })
    // this.sign_list = this.getSignList()
  },
  methods: {

    in_array(need, array) {
      need = [need];
      return need.every(val => array.includes(val));
    },

    getFillName() {

      if (this.in_array(this.itemData.control_library_id,[13,15]))
        return "*签署人";
      else if (this.in_array(this.itemData.control_library_id,[17,18,19]))
        return "*数据来源";
      else
        return  "*填写人"
    },

    /**
     * 获取配置项
     */
    getOption() {
      this.api.post("/v1/Templates/getOption", {}, (json)=>{
        if (json.code===200) {
          this.font = json.data.font
          this.fontInterval = json.data.fontInterval
          this.fontSize = json.data.fontSize
          this.doc_number_length_list = json.data.doc_number_length_list
          this.align = json.data.align,
            this.seal_type = json.data.seal_type
        }
        else {
          this.api.alert("获取配置文件失败，请重试")
        }

      })
    },
    /**
     * 获取签署人列表
     */
    getSignList() {
      let e = [];

      return [];
       this.tplContent.sign.forEach((item,index)=>{
         e.push({
           name : item.sign_role,
           value : item.sign_id
         });
      });
       return e;
    },
    getSignListName() {
      let e = ["请选择"];
      this.tplContent.sign.forEach((item,index)=>{
        e[index+1] = item.sign_role
      });
      return e;
    },
    /**
     * 更新内容
     */
    update(e) {

      this.$emit('input', e)
    },
    /**
     * 更新数组
     */
    radioUpdateValue(e) {

      // console.log(e)
      this.$emit('input-array', {field: e.field, key: e.key, value: e.value, index: e.index})
    },

    /**
     * 删除单选框
     */
    radioDelete(e) {
      this.itemData[e.field].splice(e.index, 1);
      this.updateContent(this.itemData[e.field], e.field)
      this.updateContent(this.itemData.height - 26, "height")
    },
    /**
     * 添加单选框
     */
    radioCreate(e) {
      let value = this.itemData[e.field].concat({
        id: "",
        value: "选项" + (this.itemData[e.field].length + 1)
      })

      this.updateContent(this.itemData.height + 26, "height")
      this.updateContent(value, e.field)
    },

    /**
     * 更新父窗口内容
     * @param content
     * @param field
     */
    updateContent(content, field) {
      this.$emit('input', {field: field, value: content})
    }
  },
  props: {
    itemData: {
      type: Object
    },
    maxHeight: {
      type: Number
    },
    tplContent: {
      type: Object
    },
    updateTime: {
      type: Number
    }
  },
  name: "ControlLibrarySetting"
}
</script>

<style scoped>


.ControlLibraryList {
  overflow-x: hidden;
  overflow-y: auto;
  margin-left: 30px;
  margin-right: 5px;
  height: 330px;
}

@media only screen and  (max-width:650px) {
  .ControlLibraryList {
    height: 60vh;
  }
}
.m-from-box {
  padding-left: 0;
  padding-right: 0;
  overflow: auto;
}
.form-group {

}


.m-from-box label {
  font-weight: bold;
}

.xian {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  text-align: center;
  height: 5px;
  border-bottom: 1px solid rgb(239 239 239);
}
</style>

